import React, { Component } from 'react';
import $ from 'jquery';

import CourseLayout from './../courselayout';


import {  updateCourse, getCourseById } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter } from 'reactstrap';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class editCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
          logged: localStorage.getItem("authentication"),
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          course_brochure:'',
          smallpreview:false,
          detailpreview:false,
          course_certificate_for_others:'',
          course_apply_url:''
        };
        this.getCourse = this.getCourse.bind(this);

        this.id = this.props.match.params.id 
    }

    componentDidMount() {

        this.getCourse();

    }


    getCourse(){

        let req = JSON.stringify({
            id:this.id
        })

        getCourseById(req).then(res => {
                if(res.status==1){
                    let data=res.detail;
                    this.setState({
                        course_name: data.course_name,
                        course_description: data.course_description,
                        course_duration_hrs: data.course_duration_hrs,
                        course_duration_months: data.course_duration_months,
                        course_duration_years: data.course_duration_years,
                        course_duration_days: data.course_duration_days,
                        course_eligibility: data.course_eligibility,
                        course_category:data.course_category,
                        course_level_category:data.course_level_category,
                        course_certification:data.course_certificate_for,
                        course_certification_other:data.course_certificate_for_others,
                        course_fee: data.course_fee,
                        course_fee_currency:data.course_fee_currency,
                        course_fee_per: data.course_fee_per,
                        course_moreinfo_phone:data.course_moreinfo_phone,
                        course_moreinfo_email:data.course_moreinfo_email,
                        course_apply_url:data.course_apply_url,
                        course_banner:data.course_banner,
                        course_brochure:data.course_brochure,
                        course_type:data.course_type

                    })
                    

                }

        });
    }


    smallPreview = (e) => {
        this.setState({smallpreview:true});
    }


    cancelPop1  = (e) => {
        this.setState({smallpreview:false});
    }

    cancelPop2  = (e) => {
        this.setState({detailpreview:false});
    }    

    detailPreview = (e) => {
        this.setState({detailpreview:true});
    }

    handleFile = (e) => {
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({
          [propName]: files
        });
    };

    handleChange = (e) => {
        const propName = e.target.name;
        const propValue = e.target.value;
       
        this.setState({
          [propName]: propValue
        })
    }
    

    submitCourse = (e) => {

        const { id } = this.state.auth_data;

        let req = {
          id:this.id,  
          provider_id:id,
          course_name: this.state.course_name,
          course_description: this.state.course_description,
          course_duration_hrs: this.state.course_duration_hrs,
          course_duration_months: this.state.course_duration_months,
          course_duration_years: this.state.course_duration_years,
          course_duration_days:this.state.course_duration_days,
          course_eligibility:this.state.course_eligibility,
          course_category:this.state.course_category,
          course_level_category:this.state.course_level_category,
          course_certification:this.state.course_certificate_for,
          course_certification_other:this.state.course_certificate_for_others,

          course_fee:this.state.course_fee,
          course_fee_currency:this.state.course_fee_currency,
          course_fee_per:this.state.course_fee_per,

          course_moreinfo_phone:this.state.course_moreinfo_phone,
          course_moreinfo_email:this.state.course_moreinfo_email,
          course_apply_url:this.state.course_apply_url,
          course_banner:this.state.course_banner,
          course_brochure:this.state.course_brochure,
          course_type:this.state.course_type
        };
  
        updateCourse(req).then(res => {
           
          if (res.status === 1) {
             //alert("Courses added");
             NotificationManager.success(res.message);
             setTimeout(function () {
              window.location.replace('/courses/listcourses');
             }, 1000);

          } else {
             //alert("error");
             NotificationManager.error(res.message);
          }
        });
     
    }
      


    render() {

        return (
          <React.Fragment>
          <CourseLayout>
                    
            <div class="row ">
           
              <div class="col-xl-12  nopadding">

                    <div class="wallpaper" style={{backgroundImage:`url('../../assets/books.jpg')`}}>
                        <div class="courseslogan">
                            <h3>List your course</h3>
                            <div>Help teachers learn and upskill with your courses</div>
                        </div>
                    </div>

                    <div class="addformcourse">

                        <div class="boxedform">

                                <h3>Tell us about your course</h3>
                                <div class="form-row">
                                        <label>Course name</label>
                                        <div class="form-group">
                                             <input type="text" name="course_name" class="inputcls" value={this.state.course_name} onChange={this.handleChange} />
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Course description</label>
                                        <div class="form-group">
                                             <textarea  name="course_description" value={this.state.course_description} class="inputcls" rows="5" onChange={this.handleChange} ></textarea>
                                        </div>
                                </div>
                                
                                <div class="form-row">
                                        <label>Course Category</label>
                                        <div class="form-group">
                                            <select name="course_level_category" class="inputcls selectlist" value={this.state.course_level_category} onChange={this.handleChange} >

                                                <option value="">Select Category</option>
                                                <option value="Entry Level">Entry Level</option>
                                                <option value="Intermediate">Intermediate</option>
                                                <option value="Leadership">Leadership</option>
                                                <option value="Principals">Principals</option>
                                            </select>
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Course Type</label>
                                        <div class="form-group">
                                            <select name="course_type" class="inputcls selectlist"  value={this.state.course_type} onChange={this.handleChange} >

                                                <option value="">Select Type</option>
                                                <option value="free">Free</option>
                                                <option value="paid">Paid</option>
                                            </select>
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Course Fee </label>
                                        <div class="form-group">
                                        <div class="durationflx">
                                          <select name="course_fee_currency" class="inputcls selectlist"  value={this.state.course_fee_currency} onChange={this.handleChange} >
                                            <option value="">Select Currency</option>
                                            <option value="Rs.">Indian Rupee</option>
                                            <option value="$.">US Dollar</option>
                                          </select>
                                          <input type="text" name="course_fee" class="inputcls"  value={this.state.course_fee} placeholder="Price" onChange={this.handleChange} />

                                          <select name="course_fee_per" class="inputcls selectlist"   value={this.state.course_fee_per} onChange={this.handleChange} >
                                            <option value="">Fee per?</option>
                                            <option value="per year">Per Year</option>
                                            <option value="per month">Per month</option>
                                            <option value="full course">for full course</option>
                                          </select>

                                        </div>
                                        </div>
                                </div>

                                
                                <div class="form-row">
                                        <label>Course Duration</label>
                                        <div class="form-group">
                                             <div class="durationflx">

                                                        <div class="insbox"><input type="text" name="course_duration_years"  value={this.state.course_duration_years} class="inputcls" onChange={this.handleChange} /> years</div>
                                                        <div class="insbox"><input type="text" name="course_duration_months"  value={this.state.course_duration_months} class="inputcls" onChange={this.handleChange} /> months</div>
                                                        <div class="insbox"><input type="text" name="course_duration_hrs"  value={this.state.course_duration_hrs} class="inputcls" onChange={this.handleChange} /> days</div>
                                                        <div class="insbox"><input type="text" name="course_duration_days"  value={this.state.course_duration_days} class="inputcls" onChange={this.handleChange} /> hrs</div>
                                             </div>
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Starting Date </label>
                                        <div class="form-group">
                                        <input type="date" name="course_start_date" class="inputcls"  value={this.state.course_start_date} onChange={this.handleChange} />
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Category</label>
                                        <div class="form-group">
                                         <select name="course_category" class="inputcls selectlist"  value={this.state.course_category} onChange={this.handleChange} >
                                                    <option value="Graduate in Education (BA / B.SC etc.)">Graduate in Education (BA / B.SC etc.)</option>
                                                    <option value="Post Graduate (MA /M.Sc etc)">Post Graduate (MA /M.Sc etc)</option>
                                                    <option value="Engineering Graduate">Engineering Graduate</option>
                                                    <option value="Diploma In Education">Diploma In Education</option>
                                                    <option value="Bachelors Degree in Education (B.Ed)">Bachelors Degree in Education (B.Ed)</option>
                                                    <option value="Masters Degree in Education (M.Ed)">Masters Degree in Education (M.Ed)</option>
                                                    <option value="Doctorate (Phd)">Doctorate (Phd)</option>
                                                    <option value="Bachelor of Elementray Education (B.EL.Ed)">Bachelor of Elementray Education (B.EL.Ed)</option>
                                                    <option value="Bachelor of Arts & Education (BA. B.Ed)">Bachelor of Arts & Education (BA. B.Ed)</option>
                                                    <option value="Diploma in Elementary Education (D.EL.Ed)">Diploma in Elementary Education (D.EL.Ed)</option>
                                                    <option value="Bachelor of Physical Education (B.P.Ed)">Bachelor of Physical Education (B.P.Ed)</option>
                                                    <option value="Master of Philosophy in Education (M.Phil)">Master of Philosophy in Education (M.Phil)</option>
                                                    <option value="Bachelor of Library Science (B.Lib)">Bachelor of Library Science (B.Lib)</option>
                                                    <option value="Bachelor of Library & Information Sciences (B.Lib.I.Sc)">Bachelor of Library & Information Sciences (B.Lib.I.Sc)</option>
                                                    <option value="Masters in Library & Information Sciences (M.Lib.I.Sc)">Masters in Library & Information Sciences (M.Lib.I.Sc)</option>
                                                    <option value="Bachelor of Fine Arts (BFA)">Bachelor of Fine Arts (BFA)</option>
                                                    <option value="Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)">Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)</option>
                                                    <option value="Post Graduate Diploma in Special Education">Post Graduate Diploma in Special Education</option>
                                                    <option value="Graduate in Special Education  (B.Ed - Spl Education)">Graduate in Special Education  (B.Ed - Spl Education)</option>
                                            </select>
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Course Image or Banner (if any) </label>
                                        <div class="form-group">
                                             <input type="file" name="course_banner" class="inputcls"    onChange={this.handleFile} />
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Brochure (if any) </label>
                                        <div class="form-group">
                                             <input type="file" name="course_brochure" class="inputcls"   onChange={this.handleFile} />
                                        </div>
                                </div>
                      
                               
                                <div class="form-row">
                                        <label>Certificate for </label>
                                        <div class="form-group">
                                          <select name="course_certificate_for" class="inputcls selectlist"  value={this.state.course_certificate_for} onChange={this.handleChange} >
                                          <option value="Central Teachers Eligibliity Test (CTET)">Central Teachers Eligibliity Test (CTET)</option>
                                          <option value="National Eligibility Test (NET / UGC-NET)">National Eligibility Test (NET / UGC-NET)</option>
                                          <option value="Basic Training Certificates">Basic Training Certificates</option>
                                          <option value="Primary Teachers Certificates">Primary Teachers Certificates</option>
                                          <option value="Teachers Training Certificates">Teachers Training Certificates</option>
                                          <option value="Teacher Eligiblity Test (TET)">Teacher Eligiblity Test (TET)</option>
                                          <option value="State Teachers Eligiblity Test (STET)">State Teachers Eligiblity Test (STET)</option>
                                          <option value="Certificate course in Library Sciences">Certificate course in Library Sciences</option>
                                          <option value="Certificate course in Drawing teacher training">Certificate course in Drawing teacher training</option>
                                          <option value="Certificate in Care giving program">Certificate in Care giving program</option>
                                          <option value="Certificate program in Special Education">Certificate program in Special Education</option>
                                          <option value="Certicate Courses in Dance">Certicate Courses in Dance</option>
                                          <option value="Certicate Courses in Arts">Certicate Courses in Arts</option>
                                          <option value="Certificate Courses in Sports">Certificate Courses in Sports</option>
                                          <option value="Certificate Courses in Music & Dance">Certificate Courses in Music & Dance</option>
                                          <option value="Others">Others</option>
                                          </select>
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Certificate for if Others </label>
                                        <div class="form-group">
                                             <input type="text" name="course_certificate_for_others"  value={this.state.course_certificate_for_others} class="inputcls" onChange={this.handleChange} />
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Who is eligible? </label>
                                        <div class="form-group">
                                        <textarea  name="course_eligibility" class="inputcls" rows="3"  value={this.state.course_eligibility} onChange={this.handleChange} ></textarea>

                                        </div>
                                </div>

                                

                                <div class="form-row">
                                        <label>Contacts</label>
                                        <div class="form-group flex flexalignbase">
                                        <input type="text" name="course_moreinfo_phone" placeholder='Phonenumber'  value={this.state.course_moreinfo_phone} class="inputcls" onChange={this.handleChange} />&nbsp;
                                        <input type="email" name="course_moreinfo_email" placeholder="Email Address"  value={this.state.course_moreinfo_email} class="inputcls" onChange={this.handleChange} />
                                        </div>
                                </div>

                                <div class="form-row">
                                        <label>Application URL (Enrollment for this course)</label>
                                        <div class="form-group">
                                        <input type="text" name="course_apply_url" class="inputcls"  value={this.state.course_apply_url} onChange={this.handleChange} />
                                        </div>
                                </div>

                                <div class="form-row actionbuttons">

                                    <input type="button" name="smallpreview" class="btn-main" value="Preview -Thumbnail" onClick={this.smallPreview} />&nbsp;
                                    <input type="button" name="detailpreview" class="btn-main" value="Preview -Detail" onClick={this.detailPreview} />&nbsp;
                                    <input type="button" name="submit" class="btn-main" value="Submit" onClick={this.submitCourse} />

                                </div>

                        </div>

                        <div class="spacer">&nbsp;</div>

                    </div>


                   

              </div>

            </div>

            <Modal isOpen={this.state.smallpreview} className="modalpopup">
          <ModalHeader>Thumbnail view</ModalHeader>
          <ModalBody className='p-0'>
            
                     <div className={"courserow"}>
                          <div class="courseicon">
                            <img src={"/images/courseicon.png"} />
                          </div>  
                          <div class="courseinfo">
                              <div class="courseinfo_title">{this.state.course_name}</div>
                              <div class="courseinfo_ins">Provider Name</div>
                          </div>  
                      </div>

          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPop1}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.detailpreview} className="modalpopup previewcoursedetail">
          <ModalHeader>Detail view</ModalHeader>
          <ModalBody className='p-0'>
            
            
                <div class="course_detail">        
                        <div class="courseimg">
                            <img src={"/images/coursebg.png"} />
                        </div>

                        <div class="course_title">

                                    <div class="courseinfo_title">{this.state.course_name}</div>
                                    <div class="courseinfo_desc">{this.state.course_desc}</div> 

                        </div>

                        <div class="divider"></div>

                        <div class="coursedetailtitle">Course Detail</div>    

                        <div class="courseduration">
                            <img src={"/images/clock.png"} /> {this.state.course_duration_hrs} Hours
                        </div>  

                        <div class="coursecertificates">
                            <img src={"/images/certificate.png"} /> Completion Certificate
                        </div> 

                        <div class="courseapplybutton">
                            <a href={this.state.course_apply_url} class="btn btn-main">Apply to course</a>
                        </div>   

                </div>



          </ModalBody>
          <ModalFooter>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <button className='btn btn-sm btn-default' onClick={this.cancelPop2}>Close</button>
              </div>
            </div>

          </ModalFooter>
        </Modal>

            <NotificationContainer/>
                </CourseLayout>
            </React.Fragment>
        )
    }
}


export default editCourse;


// WEBPACK FOOTER //
// ./src/components/bewise/courses/editcourse.jsx